import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import {Modal} from 'antd-mobile';
import {connect} from 'react-redux';
import {InvokeToken} from "../../../service/memberService";
import storage from '../../../utils/localStore';
import './style.less';

@connect(
    state => ({userInfo: state.userInfo})
)
export default class HistoryModule extends Component {
    constructor(props) {
        console.log(props)
        super(props);
    }

    componentDidMount() {
      
    };

    render() {
        return (
            <div className="historyModule">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >历史纪录</NavBar>
                <div className="content">
                <div className="contentBox">
                {
                    this.props.history.location.state === 1 ? 
                    <div onClick={()=>this.props.history.push('/HistoryShift')}>
                        <span>预约出行行程记录</span>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div> 
                    : null
                }
                   
                </div>
                <div className="contentBox">
                    <div onClick={()=>this.props.history.push('/ReplaceOrderList')}>
                        <span>预约出行代下单记录</span>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
                <div className="contentBox">
                    <div  onClick={()=>this.props.history.push('/ShuntOrderList')}>
                        <span>分流下单记录</span>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
                <div className="contentBox">
                    <div  onClick={()=>this.props.history.push('/RentOrderList')}>
                        <span>专车预约订单记录</span>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
                <div className="contentBox">
                    <div  onClick={()=>this.props.history.push('/CityOrderList')}>
                        <span>城内订单记录</span>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
                <div className="contentBox">
                    <div  onClick={()=>this.props.history.push('/PickHistory')}>
                        <span>接驳订单记录</span>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
            </div>
            </div>
            
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/HistoryModule/index.js